export default __webpack_public_path__ + "static/media/helm.9269e33e.png";